import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@mui/material";
import Snackbars from "../../components/Snackbar/Snackbar.js";
import { useTableDispenserUserConfig } from "./hooks";
import { DispenserUserSelectStation } from "./DispenserUserSelectStation";
import { DispenserUserSelectUnit } from "./DispenserUserSelectUnit";
import { getDispenserUser } from "../../redux/actions/dispenserUser/dispenserUserAction";

const style = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
};

export const DispenserUserInputs = () => {
  const dispatch = useDispatch();
  const { clearSnackBar } = useTableDispenserUserConfig();
  const { unit, snackBar } = useSelector(({ dispenserUser }) => dispenserUser);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(getDispenserUser(unit))
  };
  
  return (
    <>    
      <form
        onSubmit={handleSubmit}
        style={{
          width: "100%",
          padding: 4,
        }}
      >
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6} style={style}>
            <DispenserUserSelectStation />
          </Grid>

          <Grid item xs={12} sm={6} style={style}>
            <DispenserUserSelectUnit />
          </Grid>
        </Grid>
      </form>
      <Snackbars
        place="tr"
        color='danger'
        message={snackBar.msg}
        open={snackBar.isOpen}
        closeNotification={clearSnackBar}
        close
      /> 
    </> 
  );
};
